 
const HandleIfChange = (name, value, is_confirm, element,incentive_list) => { 
    let incentiveList=JSON.parse(JSON.stringify(incentive_list));
    element.scheme_type_id = '' + element.scheme_type_id || 1
    let index = incentiveList[parseInt(element.scheme_type_id)].findIndex(
        (p) => p.id === element.id
    );
    if (index === -1) return false;
    let splitted_name = name.split("_");
    
    let inputFieldName = JSON.parse(JSON.stringify(splitted_name));
    inputFieldName.pop();
    let front_name = inputFieldName.join('_'); 
    if (name === "description" ) {
        incentiveList[parseInt(element.scheme_type_id)][index][name] = value;
    }else if (name === "status") {
        if (value === false && !is_confirm) {
        } else {
            incentiveList[parseInt(element.scheme_type_id)][index][name] = value;
        }
    }else if ((front_name === "min_disb_per" || front_name === "max_disb_per" || front_name==="incentive_amount" || front_name==="incentive_amount_inr" || front_name==="incentive_amount_usd")){
        let nameSplit = name.split('_');
        let element_index =  nameSplit[nameSplit.length-1];
        nameSplit.pop();
        let element_name = nameSplit.join('_');
        incentiveList[parseInt(element.scheme_type_id)][index][element.form_config.KEY][element_index][element_name] = element.form_config.NCL && front_name === 'incentive_amount' && value.split(".").length > 1 && value.split(".").pop().length > 1 ? Number(value).toFixed(1) : value;
        conversionRateChnage(element_index); // Convert and set incentive_amount IDR to INR and vice versa

    } else if (name === "sub_schemes") {
    incentiveList[parseInt(element.scheme_type_id)][index] = {
        ...incentiveList[parseInt(element.scheme_type_id)][index],
        sub_schemes: Array.isArray(value) ? value : [],
    };
    } else{ 
        let product_type = ''
        if(name === 'product_type' && value.length > 0){
            for (let index = 0; index < value.length; index++) {
                let comma = product_type ? ',':'';
                product_type = product_type + comma + value[index].value;
            }
            element.product_type = product_type
        }
        if(name === 'scheme_duration' && value?.start){
            incentiveList[parseInt(element.scheme_type_id)][index]["scheme_duration_date"] = value.start; 
        } 
        let data = value.value    
        if(value.length > 0){
            data = product_type
        }
        incentiveList[parseInt(element.scheme_type_id)][index][name] = data;
        
        if(name === 'applicable_to' && value){ 
            incentiveList[parseInt(element.scheme_type_id)][index]["applicable_to"] = value;
        } 
        
        if(name === 'calculation_type' && value){ 
            incentiveList[parseInt(element.scheme_type_id)][index]["calculation_type"] = value;

            incentiveList[parseInt(element.scheme_type_id)][index][
              "disbursal_card"
            ] = incentiveList[parseInt(element.scheme_type_id)][index][
              "disbursal_card"
            ]?.map((card) => {
              const returnObj = {
                ...card,
                incentive_amount: "",
            }

            if (returnObj.incentive_amount_usd) {
                returnObj['incentive_amount_usd'] = "";
            }
            return returnObj;
            });
        } 

        if (name === 'ageing_days' && value) {
            incentiveList[parseInt(element.scheme_type_id)][index][
              "ageing_days"
            ] = value;
        }

        if (name === "threshold_gmv" && value) {
            incentiveList[parseInt(element.scheme_type_id)][index]["threshold_gmv"] = value;
        }

        if (name === "dealer_remaining_limit" && value) {
            incentiveList[parseInt(element.scheme_type_id)][index]["dealer_remaining_limit"] = value;
        }
    }

    function conversionRateChnage(
        element_index
    ){
        if(
            front_name 
                === 
            "incentive_amount_inr"
        ){
            incentiveList[parseInt(element.scheme_type_id)][index][element.form_config.KEY][element_index]['incentive_amount'] = (value * element.conversion_rate).toFixed(2);
        }else if(
            front_name 
                === 
            "incentive_amount"
        ){
            incentiveList[parseInt(element.scheme_type_id)][index][element.form_config.KEY][element_index]['incentive_amount_inr'] = (value / element.conversion_rate).toFixed(4);
        } else if(
            front_name 
                === 
            "max_incentive_amount_inr"
        ){
            incentiveList[parseInt(element.scheme_type_id)][index][element.form_config.KEY][element_index]['max_incentive_amount'] = (value * element.conversion_rate).toFixed(2);
        }else if(
            front_name 
                === 
            "max_incentive_amount"
        ){
            incentiveList[parseInt(element.scheme_type_id)][index][element.form_config.KEY][element_index]['max_incentive_amount_inr'] = (value / element.conversion_rate).toFixed(4);
        }
    };

    return incentiveList
};

export default HandleIfChange;